<template>
  <div  >
    <Lynx-Title
      :text="`${currentArquivoAtividade.empresa_id} - ${currentArquivoAtividade.razao_social}`"
    />

    <div v-if="currentArquivoAtividade.arquivo_dctfweb[0]">
      <v-card
        class="mb-4 p-1"
        elevation="10"
        v-if="currentArquivoAtividade.arquivo_dctfweb[0].motivoenvio"
      >
        <div class="flex justify-between items-center">
          <span
            >Motivo envio :
            {{ currentArquivoAtividade.arquivo_dctfweb[0].motivoenvio }}</span
          >

          <span class="mr-1">
            Usuario:
            {{
              currentArquivoAtividade.arquivo_dctfweb[0].usuario.nome_completo
            }}</span
          >
        </div>
      </v-card>
    </div>

      <b-table
        :loading="loading"
        :data="currentArquivoAtividade.arquivo_dctfweb"
        :columns="columns"
        style=" font-size: 13px;"
        striped
        sticky
      >
        <template slot-scope="props">
          <b-table-column
            field="arquivoAtividade"
            v-text="props.row.tipo ?? props.row.tipo_atividade"
          />
          <b-table-column field="valor">
            <div v-if="props.row.valor != null && props.row.tipo != null">
              <v-row
                v-if="
                  hasRole('super-admin') | hasPermission('editar valor guias')
                "
              >
                <v-col v-if="editable != props.row.id">
                  R$
                  {{ props.row.valor[props.row.tipo.toLowerCase()] }}
                </v-col>
                <v-col v-else>
                  <InputMoney
                    required
                    @input="
                      (money) =>
                        (props.row.valor[props.row.tipo.toLowerCase()] = money)
                    "
                    v-model="props.row.valor[props.row.tipo.toLowerCase()]"
                  ></InputMoney>
                </v-col>
                <v-col>
                  <v-btn
                    small
                    @click.native="
                      editable == props.row.id
                        ? updateVal(props.row)
                        : toggleEditable(props.row.id)
                    "
                    color="primary"
                  >
                    <v-icon size="20">{{
                      editable == props.row.id
                        ? "mdi-content-save"
                        : "mdi-pencil"
                    }}</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </b-table-column>
          <b-table-column field="user_del">
            <span
              class="p-1 text-neutral-900 text-uppercase"
              :class="{
                'bg-warning-base': props.row.user_del,
                'bg-success-base': !props.row.user_del,
              }"
            >
              {{ props.row.user_del ? "cancelado" : "Arquivo Válido" }}
            </span>
          </b-table-column>
          <b-table-column field="data_validade">
            {{ formatEnToBr(props.row.data_validade) }}
          </b-table-column>
          <b-table-column field="data_emissao">
            {{ formatEnToBr(props.row.emissao) }}
            
          </b-table-column>
          <b-table-column  field="data_competencia">
              <b-datepicker
              v-if="tipoAtividade.bloqueio"
                type="month"
                placeholder="Confirme a competência"
                icon="calendar-today"
                :month-names="monthNames"
                :day-names="dayNames"
                v-model="props.row.data_competencia"
                @input="atualizarCompetencia(props.row, false)"
              />
           
              <span v-else> {{formatEnToBr(props.row.data_competencia) }}</span>
          </b-table-column>


          <b-table-column field="data_upload">
            {{formatEnToBr(props.row.data_upload) }}
          </b-table-column>
          <b-table-column field="acoes">
            <div class="flex text-sm items-center">
              <a
                v-if="!props.row.user_del"
                :href="getArquivoAtividadeLink(props.row.arquivos[0].id)"
                target="_blank"
                class="mr-4 bg-primary-600 rounded-full p-2"
              >
                <Icon-Eye class="text-neutral-100" size="4" />
              </a>
              <a
                v-if="!props.row.user_del"
                href="#"
                class="bg-error-base rounded-full p-2"
                @click.prevent="modalCancelar(props.row)"
              >
                <Icon-Trash class="text-neutral-100" size="4" />
              </a>
              <Lynx-Button
                v-if="hasRole('super-admin') && props.row.user_del"
                icon="User"
                color="success-base"
                icon-size="3"
                size="small"
                @click.native="openLogs(props.row)"
              />
              <v-snackbar
                v-if="arquivo"
                color="primary"
                shaped
                v-model="logs"
                :vertical="false"
              >
                <span v-if="arquivo.in" style="font-size: 15px"
                  >Criou: {{ arquivo.in.nome_completo }}
                  <br />
                </span>

                <span v-if="arquivo.up" style="font-size: 15px"
                  >Atualizou: {{ arquivo.up.nome_completo }}
                  <br />
                </span>

                <span v-if="arquivo.del" style="font-size: 15px"
                  >Deletou: {{ arquivo.del.nome_completo }}
                  <br />
                </span>
                <span v-if="arquivo.motivo_cancelado" style="font-size: 15px"
                  ><span style="font-weight: bold">Motivo:</span>
                  {{ arquivo.motivo_cancelado }}
                  <br />
                </span>

                <span
                  v-if="!arquivo.del && !arquivo.in && !arquivo.up"
                  style="font-size: 15px"
                  >sem logs
                  <br />
                </span>

                <!-- <span style="font-size: 15px; margin-top: 10px;">DELETOU: {{ user_up.toUpperCase() }} </span> -->

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="error"
                    icon
                    v-bind="attrs"
                    @click.native="hide()"
                  >
                    <v-icon large> mdi-close </v-icon>
                  </v-btn>
                </template>
              </v-snackbar>
            </div>
          </b-table-column>
        </template>
      </b-table>
    <b-modal :active.sync="modalCancelado">
      <v-card elevation="10" class="p-3">
        <Lynx-Title text="Motivo Cancelar" />

        <Lynx-Textarea
          placeholder="Digite o motivo para cancelar"
          v-model="formdel.motivo_cancelado"
        />
        <div class="w-full flex justify-end items-start">
          <Lynx-Button
            icon="Cross"
            color="warning-base"
            icon-size="4"
            size="small"
            :disabled="!formdel.motivo_cancelado"
            @click.native="estornarArquivoAtividade()"
          />
        </div>
      </v-card>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import {
  estornarArquivoAtividadeRequest,
  uploadArquivoAtividadeRequest,
  atualizarArquivoAtividadeRequest,
} from "@/services/requests/arquivosAtividade";

import InputMoney from "@/components/helpers/InputMoney";
import { hasRole, hasPermission } from "@/utils/can";
import LynxTextarea from "@/components/helpers/Textarea";
import { dayNames, monthNames } from "@/utils/utils";

export default {
  name: "GerenciamentoArquivoAtividadesDetails",
  props: ["currentArquivoAtividade","tipoAtividade"],
  components: { InputMoney, LynxTextarea },

  data() {
    return {
      monthNames,
      dayNames,
      editable: null,
      guiaValor: 0,
      arquivoAtividade: null,
      modalCancelado: false,
      arquivo: null,
      logs: false,
      loading:false,
      formdel: {
        motivo_cancelado: null,
        arquivo_atividade_id: null,
      },
      columns: [
        {
          field: "arquivoAtividade",
          label: "Atividade",
        },
        {
          field: "valor",
          label: "Valor",
        },
        {
          field: "user_del",
          label: "Status",
        },
        {
          field: "data_validade",
          label: "Validade",
        },
        {
          field: "data_emissao",
          label: "Emissao",
        },
           {
          field: "data_competencia",
          label: "Compentencia",
        },
        {
          field: "data_upload",
          label: "Upload",
          width: 150,
        },
        {
          field: "acoes",
          label: "Ações",
          width: 150,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created() {
    this.convertStringToDate();
  },

  methods: {
    hasRole,
    hasPermission,
    convertStringToDate() {
      this.currentArquivoAtividade.arquivo_dctfweb.map((item) =>
        item.data_competencia
          ? (item.data_competencia = new Date(item.data_competencia))
          : null
      );
    },
    formatEnToBr(date) {
      const momentDate = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (momentDate != "Invalid date") {
        return momentDate;
      } else {
        return "sem data";
      }
    },
    getArquivoAtividadeLink(val) {
      return `${process.env.VUE_APP_API_URL}/arquivos/${val}/open?token=${this.getToken}`;
    },

    modalCancelar(arquivoAtividade) {
      this.formdel.arquivo_atividade_id = arquivoAtividade.id;
      this.modalCancelado = !this.modalCancelado;
    },
    estornarArquivoAtividade() {
      this.$buefy.dialog.confirm({
        title: "Estornar arquivo atividade",
        message: "Tem certeza que deseja estornar a arquivo atividade ?",
        confirmText: "Estornar",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          estornarArquivoAtividadeRequest(this.formdel)
            .then((data) => {
              this.currentArquivoAtividade.arquivo_dctfweb =
                this.currentArquivoAtividade.arquivo_dctfweb.map((item) => {
                  if (item.id === this.formdel.arquivo_atividade_id) {
                    return data.data.conteudo;
                  }
                  return item;
                });

              this.$snack.success(data.data.message);
              this.modalCancelado = false;
              this.$emit("estornar");
            })
            .catch((error) => {
              this.$snack.success(
                "Erro ao estornar o arquivo atividade " + error
              );
            });
        },
      });
    },

    toggleEditable($id) {
      this.editable = this.editable == $id ? null : $id;
    },

    openLogs(val) {
      this.arquivo = val;
      this.logs = true;
    },

    updateVal(data) {
      // Implemente a lógica para atualizar os valores aqui
      let arquivoAtividade = {
        id: data.id,
        valor: data.valor,
        tipo: data.tipo,
      };
      this.$buefy.dialog.confirm({
        title: "Estornar arquivo atividade",
        message:
          "Tem certeza que deseja alterar o valor da arquivo atividade " +
          arquivoAtividade.tipo +
          " ?",
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          uploadArquivoAtividadeRequest(arquivoAtividade).then(() => {
            this.toggleEditable();
            this.$emit("atualizar");
          });
        },
      });
    },
    async atualizarCompetencia(atividade) {
      this.loading = true;
      await atualizarArquivoAtividadeRequest(atividade).then(
        (data) => {
        this.$snack.success(data.data.message);

          this.loading = false;
        }
      );
    },
  },
  filters: {
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    data_upload(guia) {
      if (guia.data_upload) {
        return new Date(guia.data_upload).toLocaleString();
      }
    },
  },
};
</script>

<style>
</style>
